"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpDataType = /** @class */ (function () {
    function HttpDataType() {
    }
    HttpDataType.TEXT = "text";
    return HttpDataType;
}());
exports.default = HttpDataType;
//# sourceMappingURL=HttpDataType.js.map